import { IAppState } from '../../redux';
import { ECheckServiceStatus, EPublishOfferStatus } from '../../redux/reducers';

export function selectIsPublishButtonPending(state: IAppState): boolean {
  const { checkoutInfo, publishInfo } = state;

  return checkoutInfo.status === ECheckServiceStatus.pending || publishInfo.status === EPublishOfferStatus.pending;
}
